import { get, post } from '../http';
import { SearchFilters } from '../types';

const BASE_URL = process.env.NEXT_PUBLIC_REST_API_URL as string;

export const Routes = {
  fetch: '/entities',
  filtered: '/entities/filtered',
  autocomplete: '/entities/search/autocomplete',
  search: '/entities/search',
  missingIndexes: '/entities/search/missing-indexes?page=',
  favorites: '/entities/favorites',
  shared: '/entities/shared'
};

export const fetch = async ({ folderId }: { folderId?: string | string[] }) => {
  let url = BASE_URL + Routes.fetch;
  if (folderId) {
    url += '?folder_id=' + folderId;
  }

  return get({ url });
};

export const fetchFiltered = async ({ filters }: { filters: SearchFilters }) => {
  const restUrl = BASE_URL + Routes.filtered;
  return post({ url: restUrl, body: JSON.stringify(filters) });
};

export const autocomplete = async (query: string) => {
  const url = `${BASE_URL}${Routes.autocomplete}?query=${query}`;
  return get({ url });
};

export const search = async ({ filters }: { filters: SearchFilters }) => {
  const url = BASE_URL + Routes.search;
  return post({ url, body: JSON.stringify(filters) });
};

export const favorites = async () => {
  const url = BASE_URL + Routes.favorites;
  return get({ url });
};

export const shared = async ({ pageParam }: { pageParam?: number } = {}) => {
  const page = pageParam || 1;
  const url = `${BASE_URL}${Routes.shared}?page=${page}`;
  return get({ url });
};

export const missingIndexes = async ({
  filters,
  pageParam
}: {
  filters: SearchFilters;
  pageParam: number | undefined;
}) => {
  pageParam = pageParam || 1;
  const url = BASE_URL + Routes.missingIndexes + pageParam;
  return post({ url, body: JSON.stringify(filters) });
};
